package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.common.api.GoogleFormApi
import com.eladfinish.bible.contest.common.api.GoogleFormApiImpl
import com.eladfinish.bible.contest.network.ApiBaseUrlProvider
import com.eladfinish.bible.contest.network.HttpClientFactory
import com.eladfinish.bible.contest.network.RemoteApiBaseUrlProvider
import com.eladfinish.bible.contest.network.config.NetworkConfiguration
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApiImpl
import com.eladfinish.bible.contest.screens.chapterComplete.api.ChapterCompleteApi
import com.eladfinish.bible.contest.screens.chapterComplete.api.ChapterCompleteApiImpl
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.GeneratePdfFromHtmlApiUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.GeneratePdfFromHtmlApiUseCaseImpl
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SendHtmlEmailUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SendHtmlEmailUseCaseImpl
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SendPdfEmailUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SendPdfEmailUseCaseImpl
import com.eladfinish.bible.contest.screens.main.api.MainApi
import com.eladfinish.bible.contest.screens.main.api.MainApiImpl
import com.eladfinish.bible.contest.screens.mikud.api.MikudApi
import com.eladfinish.bible.contest.screens.mikud.api.MikudApiImpl
import com.eladfinish.bible.contest.screens.mikud.api.SyllabusGithubApi
import com.eladfinish.bible.contest.screens.mikud.api.SyllabusGithubApiImpl
import com.eladfinish.bible.contest.screens.names.api.NamesGithubApi
import com.eladfinish.bible.contest.screens.names.api.NamesGithubApiImpl
import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleDriveApi
import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleDriveApiImpl
import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleScriptApi
import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleScriptApiImpl
import com.eladfinish.bible.contest.screens.search.ai.remote.AiSearchApi
import com.eladfinish.bible.contest.screens.search.ai.remote.AiSearchApiImpl
import com.eladfinish.bible.contest.screens.search.api.SearchGithubApi
import com.eladfinish.bible.contest.screens.search.api.SearchGithubApiImpl
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.bind
import org.koin.dsl.module

fun apiModule(withCache: Boolean = true) = module {

    single {
        HttpClientFactory.createHttpClient(
            clientConfig = NetworkConfiguration(debugInfo = get()),
            cacheHelper = if (withCache) get() else null,
        )
    }

    factoryOf(::MainApiImpl) bind MainApi::class
    factoryOf(::MikudApiImpl) bind MikudApi::class
    factoryOf(::SyllabusGithubApiImpl) bind SyllabusGithubApi::class
    factoryOf(::ChapterCompleteApiImpl) bind ChapterCompleteApi::class

    factoryOf(::GoogleFormApiImpl) bind GoogleFormApi::class

    factoryOf(::AiSearchApiImpl) bind AiSearchApi::class
    factoryOf(::SearchGithubApiImpl) bind SearchGithubApi::class
    factoryOf(::NamesGithubApiImpl) bind NamesGithubApi::class

    factoryOf(::SendPdfEmailUseCaseImpl) bind SendPdfEmailUseCase::class
    factoryOf(::SendHtmlEmailUseCaseImpl) bind SendHtmlEmailUseCase::class
    factoryOf(::GeneratePdfFromHtmlApiUseCaseImpl) bind GeneratePdfFromHtmlApiUseCase::class

    factoryOf(::SpreadsheetApiImpl) bind SpreadsheetApi::class
    factoryOf(::GoogleScriptApiImpl) bind GoogleScriptApi::class
    factoryOf(::GoogleDriveApiImpl) bind GoogleDriveApi::class

    factoryOf(::RemoteApiBaseUrlProvider) bind ApiBaseUrlProvider::class
}
